import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useProfiles } from "../lib/profiles.js";
import { TwinClient } from "../lib/client"
import { ButtonOk } from "../Components/Buttons.js";
import { validateTwinUrl } from "../lib/validation.js";
import { Page } from "../Components/page.js";

async function handleLogin(url, apiKey, setProfile, setActiveProfile, navigate) {
  let client = new TwinClient({ url, apiKey });
  let result = await client.info(); // FIXME(acg): this doesn't actually verify creds
  // PERF(sfertman): maybe ping a lighter endpoint to verify creds
  if (!result) {
    return navigate("/login");
  } else {
    let { address, binderId } = await client.info();
    setProfile(url, {
      address,
      binderId,
      client: { url, apiKey },
    })
    setActiveProfile(url);
    return navigate("/home")
  }
}

export default function Login() {
  const { setProfile, setActiveProfile } = useProfiles();
  const navigate = useNavigate();
  let [searchParams, _] = useSearchParams();

  function doLogin(e) {
    e.preventDefault();
    let form = e.target;
    let formData = new FormData(form);
    let url = formData.get("url");
    let apiKey = formData.get("apiKey");
    handleLogin(url, apiKey, setProfile, setActiveProfile, navigate);
  }
  // Example twins we can work with:



  // url login
  // http://localhost:3000/login?twin-url=https://41f33a6c397b4bca97bb5616acd7fe39.tracker-demo.biz.todaq.net&twin-api-key=c99c7e58-a71e-4529-8b88-3cf5dc92a7a3
  // https://app.treasury.todaq.net/login?twin-url=https://41f33a6c397b4bca97bb5616acd7fe39.tracker-demo.biz.todaq.net&twin-api-key=c99c7e58-a71e-4529-8b88-3cf5dc92a7a3

  // https://41f33a6c397b4bca97bb5616acd7fe39.tracker-demo.biz.todaq.net
  // c99c7e58-a71e-4529-8b88-3cf5dc92a7a3

  // http://localhost:3000/login?twin-url=https://4103432af1f870c5289fb951ad236d7d.tracker-demo.biz.todaq.net&twin-api-key=69de0132-60ea-4b30-8faa-efbdbfa22ec6
  // https://4103432af1f870c5289fb951ad236d7d.tracker-demo.biz.todaq.net
  // 69de0132-60ea-4b30-8faa-efbdbfa22ec6

  const queryString = window.location.search;

  const urlParams = new URLSearchParams(queryString);
  const [validUrl, setValidUrl] = useState(null);

  function validateUrl(e) {
      let twinUrl = e.target.value;
    setValidUrl(null);

    let result = validateTwinUrl(twinUrl);
    if (result == null) {
      setValidUrl(twinUrl);
    }
  }

  if (urlParams.has("twin-url") && urlParams.has("twin-api-key")) {
    let twinUrl = urlParams.get("twin-url");
    let twinApiKey = urlParams.get("twin-api-key");
    handleLogin(twinUrl, twinApiKey, setProfile, setActiveProfile, navigate);
    useEffect(() => {
      if (twinUrl) {
        validateUrl({ target: twinUrl }) // HAACK
      }
      handleLogin(twinUrl, twinApiKey, setProfile, setActiveProfile, navigate);
    }, [searchParams, setProfile, setActiveProfile, navigate]);
  } else {
    useEffect(() => {
      let twinUrl = searchParams.get("twin-url");
      let twinApiKey = searchParams.get("twin-api-key")
      if (twinUrl && twinUrlInput?.current) {
        twinUrlInput.current.value = twinUrl;
        if (twinUrl) {
          validateUrl({ target: twinUrl }) // HAACK
        }
        if (twinApiKey) {
          document.getElementById("twin-api-key").defaultValue = twinApiKey;
        }
      }
    }, [searchParams]);
  }

  let twinUrlInput = useRef(null);
  let twinApiKeyInput = useRef(null);

    return <Page title="Bank Gateway: Login">
        <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <form onSubmit={doLogin} class="space-y-6">
            <div>
              <label htmlFor="twin-url"
                class="block text-sm/6 font-medium text-gray-900 dark:text-gray-100">
                Account URL
    </label>
        <div class="mt-2">
              <input
                id="twin-url"
                ref={twinUrlInput}
                type="text"
                name="url"
                onChange={validateUrl}
                onChangeCapture={validateUrl}
                data-invalid={!validUrl}
                placeholder="https://"
                className="p-1 border block w-full text-gray-800 data-[invalid=true]:text-red-600 " /></div>
            </div>
            <div>
              <label
                htmlFor="twin-api-key"
                class="block text-sm/6 font-medium text-gray-900 dark:text-gray-100">
                Account Access Code
    </label>
        <div class="mt-2">
              <input
                id="twin-api-key"
                ref={twinApiKeyInput}
                type="password"
                required
                name="apiKey"
                placeholder="00000000-0000-0000-0000-000000000000"
    className="p-1 border block w-full text-gray-800" />
        </div>
            </div>
            <div className="gap-6 flex flex-col">
              <ButtonOk type="submit" disabled={!validUrl}>
                Login
              </ButtonOk>
            </div>
        </form>
      </div>
    </div>
  </Page>;
}
